import { Box, SimpleGrid, Stack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useMetrics } from "../../../hooks/metrics/useMetrics";
import { ManagerProfileCover } from "../ManagerProfileCover";
import { ManagerProfileDivider } from "../ManagerProfileDivider";
import {
  ManagerProfileEditingSection,
  ManagerProfileProvider,
  useManagerProfile,
} from "../ManagerProfileProvider";
import { Details } from "../sections/Details";
import { Opportunities } from "../sections/Opportunities";
import { Overview } from "../sections/Overview";
import { Team } from "../sections/Team";
import { TrackRecord } from "../sections/TrackRecord";
import { Video } from "../sections/Video";
import { ManagerProfileProps } from "./ManagerProfile.types";

export const ManagerProfile: React.FC<ManagerProfileProps> = ({
  manager,
  isEditor,
  refreshManager,
  onShowKeyPeopleOnDashboard,
  ...rest
}) => {
  const managerId = manager.id;
  const sendMetric = useMetrics();
  const managerProfileContext = useManagerProfile(true);

  const { editingDrawer } = managerProfileContext || {};

  const isGreyedOut =
    editingDrawer === ManagerProfileEditingSection.Opportunities;

  useEffect(() => {
    if (managerId && !isEditor) {
      sendMetric({
        event_type: "view",
        object_id: parseInt(String(managerId)),
        object_type: "managers",
      });
    }
  }, [managerId]); // eslint-disable-line react-hooks/exhaustive-deps

  const Profile = (
    <Box {...rest}>
      {isGreyedOut && (
        <Box
          position={"absolute"}
          left={0}
          right={0}
          top={0}
          bottom={0}
          background={"#efefef"}
          opacity={0.5}
          zIndex={100}
        />
      )}
      <ManagerProfileCover
        mb={10}
        manager={manager}
        refreshManager={refreshManager}
      />
      <ManagerProfileDivider />
      <Stack spacing={14}>
        <SimpleGrid columns={{ base: 1, md: 2 }} w={"100%"}>
          <Overview />
          <Video />
        </SimpleGrid>

        <Opportunities />
        <Details />
        <Team onShowKeyPeopleOnDashboard={onShowKeyPeopleOnDashboard} />
        <TrackRecord />
      </Stack>
    </Box>
  );

  if (managerProfileContext && managerProfileContext.manager) {
    return Profile;
  }

  return (
    <ManagerProfileProvider manager={manager} isEditor={isEditor}>
      {Profile}
    </ManagerProfileProvider>
  );
};
